require('./').polyfill()



//////////////////
// WEBPACK FOOTER
// ./node_modules/raf/polyfill.js
// module id = 894
// module chunks = 1